import React from 'react';
import { Button, Modal } from 'react-bootstrap';

class HelpModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.show,
    };
  }

  render() {
    const { title, contentUrl } = this.props;
    const { showModal } = this.state;
    return (
      <div>
        <Button
          bsStyle="link"
          style={{ color: 'unset' }}
          onClick={() => this.setState({ showModal: true })}
        >
          <i className="fa fa-info-circle" style={{ fontSize: '1.5em' }} />
        </Button>
        <Modal
          show={showModal}
          onHide={() => this.setState({ showModal: false })}
          bsSize="large"
          dialogClassName="help-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              !!contentUrl ? (<iframe src={contentUrl} frameborder="0" width="100%" height="100%" />)
                : (<span>No content.</span>)
            }
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

HelpModal.defaultProps = {
  title: '',
  contentUrl: '',
  show: false,
};

export default HelpModal;



// WEBPACK FOOTER //
// ./src/modal/help/HelpModal.js